import { combineEpics, ofType } from 'redux-observable';
import { switchMap, catchError, mergeMap } from 'rxjs/operators';
import { normalize } from 'normalizr';
import api from 'api/index';
import { handleError } from 'base/errors/store/actions';
import * as actionTypes from './actionTypes';
import {
  fetchDefaultFavoritesSuccess,
  addDefaultFavoriteSuccess,
  removeDefaultFavoriteSuccess,
  fetchDashboardsWithFavoriteDocumentSuccess,
} from './actions';
import { dashboardsSchema, documentsSchema, favoritesSchema } from '../../../store/schema';
import { entitiesFetchSuccess } from '../../../store/entities/actions';

const fetchEpic = action$ =>
  action$.pipe(
    ofType(actionTypes.FETCH),
    switchMap(action => {
      if (!action.dashboardId) {
        return [fetchDefaultFavoritesSuccess([])];
      }
      return api.defaultFavorites.fetchAll(action.dashboardId).pipe(
        mergeMap(response => {
          const { entities } = normalize(response.body, favoritesSchema);
          const ids = response.body.map(f => f.favorite.id);
          return [entitiesFetchSuccess(entities), fetchDefaultFavoritesSuccess(ids)];
        }),
        catchError(error => [handleError(error)]),
      );
    }),
  );

const fetchDashboardsWithFavoriteDocumentEpic = action$ =>
  action$.pipe(
    ofType(actionTypes.FETCH_DASHBOARDS_WITH_DEFAULT_FAVORITE),
    switchMap(action =>
      api.defaultFavorites.fetchAllDashboardsWithFavoriteDocument(action.entityType, action.entityId).pipe(
        mergeMap(response => {
          const { entities, result } = normalize(response.body, dashboardsSchema);
          return [entitiesFetchSuccess(entities), fetchDashboardsWithFavoriteDocumentSuccess(result)];
        }),
        catchError(error => [handleError(error)]),
      ),
    ),
  );

const addDocumentEpic = action$ =>
  action$.pipe(
    ofType(actionTypes.ADD_FAVORITE),
    mergeMap(action =>
      api.defaultFavorites.addFavorite(action.dashboardId, action.entityType, action.entityId).pipe(
        mergeMap(response => {
          const { entities } = normalize(response.body, documentsSchema);
          return [entitiesFetchSuccess(entities), addDefaultFavoriteSuccess(action.entityId)];
        }),
        catchError(error => [handleError(error)]),
      ),
    ),
  );

const removeDocumentEpic = action$ =>
  action$.pipe(
    ofType(actionTypes.REMOVE_FAVORITE),
    mergeMap(action =>
      api.defaultFavorites.removeFavorite(action.dashboardId, action.entityType, action.entityId).pipe(
        mergeMap(() => [removeDefaultFavoriteSuccess(action.entityId)]),
        catchError(error => [handleError(error)]),
      ),
    ),
  );

export default combineEpics(fetchEpic, addDocumentEpic, removeDocumentEpic, fetchDashboardsWithFavoriteDocumentEpic);
